import { render, staticRenderFns } from "./block-document-participants.vue?vue&type=template&id=446b123e&scoped=true&lang=pug"
import script from "./block-document-participants.vue?vue&type=script&lang=js"
export * from "./block-document-participants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446b123e",
  null
  
)

export default component.exports